<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3>
          <slot name="title"></slot>
        </h3>
        <div class="node-state"
             style="margin-left:1%;margin-bottom:1%;margin-top: 0.5%;"
             v-for="radioObj of constructionControlDataArr"
             :key="radioObj.nodeName">
          <h4>{{radioObj.nodeName}}</h4>
          <div class="item-state"
               style="padding-left: 1%;margin-bottom:0.5%;padding-bottom:0.5%;"
               v-for="radioData of radioObj.subnodelist"
               :key="radioData.nodeName"
               @change="radioChange">
            <span>{{radioData.nodeName}}</span><br>
            <qe-radio-image-upload :src="src"
                                   :isPic="true"
                                   :picImgs="radioData.picArr"
                                   :nodeName="radioObj.nodeName"
                                   :subNodeName="radioData.nodeName"
                                   @getDataArrPic="getDataArrPic"
                                   style="width: 80%; padding: 20px 0px 0px 0px;">
              <i slot="del"
                 class="del-p"></i>
            </qe-radio-image-upload>
            <template>
              <el-radio-group v-model="radioData.nodeState"
                              text-color="#626aef"
                              size="small"
                              fill="rgb(239, 240, 253)"
                              style="margin-bottom:1%;margin-top: 0.5%;">
                <el-radio border
                          :label=1>良好</el-radio>
                <el-radio border
                          :label=2>预警</el-radio>
                <el-radio border
                          :label=3>异常</el-radio>
              </el-radio-group>
            </template>
            <div class="create-title-p"
                 style="margin:0px;">
              <input type="text"
                     placeholder="描述"
                     v-model="radioData.remark" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QeRadioImageUpload from './qeRadioImageUpload.vue'

export default {
  name: 'constructionControlNode',
  data () {
    return {
      src1: require("../../../../../html/pages/originality/createQe/images/upload.jpg"),
      type: '',
      //nodeState 1-良好 2-预警 3-异常
      constructionControlDataArr: [
        {
          nodeName: "1.材料用量和配比",
          subnodelist: [
            {
              nodeName: "a.施工现场材料用量和配比需符合销售订单量、需符合公司标准；",
              remark: "",
              nodeState: 0,
              picArr: []
            }
          ]
        },
        {
          nodeName: "2.材料搅拌",
          subnodelist: [
            {
              nodeName: "a.搅拌设备需符合公司要求；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "b.搅拌需充分、均匀；",
              remark: "",
              nodeState: 0,
              picArr: []
            }
          ]
        },
        {
          nodeName: "3.基础处理剂",
          subnodelist: [
            {
              nodeName: "a.滚涂/喷涂均匀，无露底、无积料；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "b.搅拌需充分、均匀；",
              remark: "",
              nodeState: 0,
              picArr: []
            }
          ]
        },
        {
          nodeName: "4.弹性底层摊铺（检查接缝、平整度、密实度）",
          subnodelist: [
            {
              nodeName: "a.底层颗粒无明显松动、脱落、过水失胶现象；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "b.底层颗粒表观平整密实，接缝无明显高低，无裂纹，不毛糙，按压有强度；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "c.底层厚度控制达到设计要求；",
              remark: "",
              nodeState: 0,
              picArr: []
            }
          ]
        },
        {
          nodeName: "5.中间层",
          subnodelist: [
            {
              nodeName: "a.要求表面无漏底、无麻面、无凹凸、无明显接缝、无堆积料；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "b.要求表面平整无积水，闭水试验，2m靠尺，积水深度小于3mm；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "c.中间层应完全干燥（多点测试，湿度小于6%）；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "d.要求表面无起鼓、无气泡。",
              remark: "",
              nodeState: 0,
              picArr: []
            }
          ]
        },
        {
          nodeName: "6.面层",
          subnodelist: [
            {
              nodeName: "a.查看施工天气，下雨前12h不施工；环境温度高于35℃、低于5℃时不施工；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "b.滚涂型面层表观均匀不发花、场地洁净、无漏底、无接缝、无滚筒印、无堆积、无气泡；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "c.喷涂型面层要求胶水包裹均匀饱满，面层颗粒呈包浆状态，无毛糙感，与下层材料粘结牢固，站立目测无明显色差、无漏底；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "d.面层混合料需在5-10分钟内用完，严禁使用有结皮现象的混合料，严禁兑水；",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "e.同种颜色的面层材料若存在不同批号，应分开放置并妥善管理。",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "f.在进行最后一遍面层施工时，必须使用同一批号的材料，以确保表面颜色的一致性。",
              remark: "",
              nodeState: 0,
              picArr: []
            },
            {
              nodeName: "g.完工7天后，穿运动鞋脚跟旋转，观察面层颗粒牢固度，是否有颗粒脱落；",
              remark: "",
              nodeState: 0,
              picArr: []
            }
          ]
        }
      ]
    }
  },
  components: {
    QeRadioImageUpload
  },
  computed: {
    src () {
      return this.src1
    }
  },
  methods: {
    init () {
      this.type = this.$route.query.type
    },
    created () {
      this.init()
    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.init();
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
    radioChange () {
      this.$emit('getConstructionControlData', this.constructionControlDataArr);
    },
    getDataArrPic (nodeName, imageName, data) {
      for (let subnode of this.constructionControlDataArr) {
        if (subnode.nodeName == nodeName) {
          for (let grandsonnode of this.constructionControlDataArr) {
            if (grandsonnode.nodeName == imageName) {
              grandsonnode.picArr = data
            }
          }
        }
      }
      this.$emit('getConstructionControlData', this.constructionControlDataArr);
    },
  },
}
</script>

<style scoped>
</style>
